import fixture from './sampleBillData.json';

// Resettable splitting playground. All amounts are cents.
export const samplePeople = fixture.people;
export const sampleItems = fixture.items;
export const sampleSubtotal = fixture.subtotal;
export const sampleTax = fixture.tax;
export const sampleTotal = sampleSubtotal + sampleTax;
export type SampleAssignments = number[][];
export const initialAssignments = (): SampleAssignments => fixture.assignments.map(people => [...people]);
export const sampleMoney = (cents: number) => `$${(cents / 100).toFixed(2)}`;

function apportion(cents: number, weights: number[]) {
  const weight = weights.reduce((sum, value) => sum + value, 0);
  const amounts = weights.map(value => Math.floor(cents * value / weight));
  const order = weights.map((value, index) => ({ index, remainder: (cents * value) % weight }))
    .sort((a, b) => b.remainder - a.remainder || a.index - b.index);
  const remaining = cents - amounts.reduce((sum, amount) => sum + amount, 0);
  for (let index = 0; index < remaining; index++) amounts[order[index].index]++;
  return amounts;
}

export function calculateSampleSplit(assignments: SampleAssignments) {
  // Six units per cent keeps halves and thirds exact. The fourth bucket reserves
  // unassigned items and their tax instead of charging them to somebody else.
  const weights = [0, 0, 0, 0];
  sampleItems.forEach((item, index) => {
    const people = assignments[index];
    if (!people.length) weights[3] += item.amount * 6;
    else people.forEach(person => { weights[person] += item.amount * 6 / people.length; });
  });
  const subtotals = apportion(sampleSubtotal, weights);
  const totals = apportion(sampleTotal, weights);
  return {
    shares: samplePeople.map((name, index) => ({
      name, subtotal: subtotals[index], tax: totals[index] - subtotals[index], total: totals[index],
    })),
    unassigned: totals[3],
    unassignedCount: assignments.filter(people => !people.length).length,
  };
}
